import { VerificationCode } from '@/components'
import { routes } from '@/router'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export function ConfirmEmailPage() {
  const navigate = useNavigate()

  const handleSuccessEmailVerification = () => {
    navigate(routes.session.signup.password)
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <VerificationCode
        type="email"
        gap={1}
        maxWidth={265}
        margin="auto"
        onSuccess={handleSuccessEmailVerification}
      />
    </Box>
  )
}
